export default __webpack_public_path__ + "static/media/icaew_l1.b058cf2b.png";